/* eslint-disable no-empty */
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';
import axios, { Method } from 'axios';

const request = async (
  endpoint: string,
  method: Method,
  body?: any,
  header?: Record<string, string>,
  authHeaders?: boolean,
) => {
  let combinedAuthHeaders = undefined;

  try {
    if (authHeaders) {
      const session = await fetchAuthSession();

      const user = await getCurrentUser();

      combinedAuthHeaders = {
        Authorization: `Bearer ${session.tokens?.accessToken.toString()}`,
        'x-user-id': user.userId ?? '',
        'x-country': 'gb',
        ...header,
      };
    }
    return await axios({
      method,
      url: endpoint,
      headers: authHeaders
        ? combinedAuthHeaders
        : {
            ...header,
            'x-country': 'gb',
          },
      data: body,
    });
  } finally {
  }
};

export default request;
